<template>
  <basic-header pretitle="aqfer Universal Tag" title="Tag Reports" :compact="true" />
  <div class="container-fluid mt-3" id="tag_reports">
    <Tabs :tabs="tabItems">
      <template v-slot:tagReport>
        <div class="row class-menu mt-4">
          <div class="col-md-12">
            <div class="mb-2">Choose a Class</div>
            <button style="margin-right: 10px" key="all" @click="currentCls = null" class="btn card-header-title"
              :class="[!currentCls ? 'active btn-primary' : 'btn-secondary']">
              All
            </button>
            <button style="margin-right: 10px" v-for="classItem in classItems"
              :key="classItem.cls == 'NA' ? 'default' : classItem.cls" @click="currentCls = classItem.cls"
              class="btn card-header-title" :class="[
                currentCls == classItem.cls ? 'active btn-primary' : 'btn-secondary',
              ]">
              {{ classItem.cls == "NA" ? "default" : classItem.cls }}
            </button>
          </div>
        </div>
        <div class="row class-menu">
          <div class="col-md-3">
            <input-field label="Report" type="select" :options="reportOptions" v-model="reportType" />
          </div>
          <div class="col-md-3">
            <input-field label="Date(UTC)" type="select" :options="dateOptions" v-model="dateType" />
          </div>
          <div class="col-md-3 my-auto">
            <div class="custom-control form-switch">
              <input type="checkbox" class="form-check-input" id="customSwitch1" v-model="showDaySplit" />
              <label style="padding-left: 5px" class="form-check-label" for="customSwitch1">Daily Report</label>
            </div>
          </div>
          <div class="col-md-3 my-auto text-end">
            <button class="btn btn-primary" @click="loadCounts">Generate</button>
          </div>
        </div>
        <div class="row class-menu">
          <div class="col-md-3" v-if="dateType == 'custom'">
            <input-field label="Start Date(UTC)" type="calendar" v-model="startDate" :inputConfig="config" />
          </div>
          <div class="col-md-3" v-if="dateType == 'custom'">
            <input-field label="End Date(UTC)" type="calendar" v-model="endDate" :inputConfig="config" />
          </div>
        </div>
        <div class="error" v-if="errMode">
          <p>{{ errMsg }}</p>
        </div>
        <div class="alert alert-warning" v-if="countryDataWarning && reportType == 'country' && !errMode">
          Country-level data is only available for past 90 days. Results may
          not include data before that.
        </div>
        <div v-if="reportType == 'tag_type' && !errMode">
          <div class="row align-items-end justify-content-between mb-1">
            <div class="col-md-9">
              <h3 class="">Counts By Tag Type</h3>
            </div>
            <div class="col">
              <div class="input-group float-end w-75">
                <span class="input-group-text">Threshold</span>
                <input type="number" class="form-control" aria-label="limit" v-model="threshold_tagType" step="1000" />
              </div>
            </div>
          </div>
          <div class="">
            <div class="card" v-if="showDaySplitTable && showDaySplit">
              {{ currentCls }}
              <datatable :key="tagDailyColumns.length" :tableId="`dailyTagCountList-${currentCls || 'all'}`"
                :columns="tagDailyColumns" :data="filteredCountsPixel || []" :scrollX="true" :compact="true"
                @exportCSV="(data) => exportCSV('tagtype_day_counts', data)" :enableCSVExport="true"
                :showLoading="filteredCountsPixel === null" />
            </div>
            <div class="card" v-if="!showDaySplit">
              <datatable :key="tagColumns.length" :tableId="`tagCountList-${currentCls || 'all'}`" :columns="tagColumns"
                :data="filteredCountsPixel || []" :scrollX="true" :compact="true"
                @exportCSV="(data) => exportCSV('tagtype_count', data)" :enableCSVExport="true"
                :showLoading="filteredCountsPixel === null" />
            </div>
          </div>
          <div class="row align-items-end justify-content-between mb-1">
            <div class="col-md-9">
              <h3>Counts By Partner Domain</h3>
            </div>
            <div class="col">
              <div class="input-group float-end w-75">
                <span class="input-group-text">Threshold</span>
                <input type="number" class="form-control" aria-label="limit" v-model="threshold_partnerBeacon"
                  step="1000" />
              </div>
            </div>
          </div>
          <div class="">
            <div class="card" v-if="showDaySplitTable && showDaySplit">
              <datatable :key="partnerDailyColumns.length" :tableId="`partnerDailyCountList-${currentCls}`"
                :columns="partnerDailyColumns" :data="filteredCountsPartnerBeacon || []" :scrollX="true" :compact="true"
                @exportCSV="(data) => exportCSV('partner_domain_day_counts', data)" :enableCSVExport="true"
                :showLoading="filteredCountsPartnerBeacon === null" />
            </div>
            <div class="card" v-if="!showDaySplit">
              <datatable :key="partnerColumns.length" :tableId="`partnerCountList-${currentCls}`"
                :columns="partnerColumns" :data="filteredCountsPartnerBeacon || []" :scrollX="true" :compact="true"
                @exportCSV="(data) => exportCSV('partner_domain_count', data)" :enableCSVExport="true"
                :showLoading="filteredCountsPartnerBeacon === null" />
            </div>
          </div>
          <div class="row align-items-end justify-content-between mb-1">
            <div class="col-md-9">
              <h3>Counts By Redirect Domain</h3>
            </div>
            <div class="col">
              <div class="input-group float-end w-75">
                <span class="input-group-text">Threshold</span>
                <input type="number" class="form-control" aria-label="limit" v-model="threshold_redirect" step="1000" />
              </div>
            </div>
          </div>
          <div class="">
            <div class="card" v-if="showDaySplitTable && showDaySplit">
              <datatable :key="directDailyColumns.length" tableId="redirectDailyCountList" :columns="directDailyColumns"
                :data="filteredCountsRedirectPixel || []" :scrollX="true" :compact="true"
                @exportCSV="(data) => exportCSV('redirect_domain_day_counts', data)" :enableCSVExport="true"
                :showLoading="filteredCountsRedirectPixel === null" />
            </div>
            <div class="card" v-if="!showDaySplit">
              <datatable :key="directColumns.length" tableId="redirectCountList" :columns="directColumns"
                :data="filteredCountsRedirectPixel || []" :scrollX="true" :compact="true"
                @exportCSV="(data) => exportCSV('redirect_domain_counts', data)" :enableCSVExport="true"
                :showLoading="filteredCountsRedirectPixel === null" />
            </div>
          </div>
        </div>
        <div v-if="reportType == 'country' && !errMode">
          <div class="row align-items-end justify-content-between mb-1">
            <div class="col-md-9">
              <h3 class="">Counts By Tag Type</h3>
            </div>
            <div class="col">
              <div class="input-group float-end w-75">
                <span class="input-group-text">Threshold</span>
                <input type="number" class="form-control" aria-label="limit" v-model="threshold_country" step="1000" />
              </div>
            </div>
          </div>
          <div class="">
            <div class="card" v-if="!showDaySplit && showCountryListTable">
              <datatable tableId="CountryCountList" :columns="countryColumns" :data="filteredCountsCountry || []"
                :scrollX="true" :compact="true" @exportCSV="(data) => exportCSV('Tag_country_counts', data)"
                :enableCSVExport="true" :showLoading="filteredCountsCountry === null" />
            </div>
            <div class="card" v-if="showDaySplit">
              <div class="row card-body">
                <div class="col-sm-2">
                  <h3>Filters:</h3>
                </div>
                <div class="col-sm-3">
                  <div class="input-container">
                    <label class="input-label">Country &nbsp;</label>
                    <select v-model="selectedCountry">
                      <option value="All:All">All</option>
                      <option v-for="option in countriesUnique" :key="option.cc" :value="option.cc">
                        {{ option.cc }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-4" v-if="!splitByStatus">
                  <div class="input-container">
                    <label class="input-label">TagType &nbsp;</label>
                    <select v-model="selectedTag">
                      <option value="All:All">All</option>
                      <option v-for="option in tagTypesUnique" :key="option.tagtype" :value="option.tagType">
                        {{ option.tagType }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- <div
                  :class="showsplitByStatusTable ? 'col-md-7' : 'col-md-3'"
                  class="my-auto text-end"
                >
                  <div class="custom-control form-switch">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      id="customSwitch2"
                      v-model="splitByStatus"
                    />
                    <label
                      style="padding-left: 5px"
                      class="form-check-label"
                      for="customSwitch2"
                      >Split By Status</label
                    >
                  </div>
                </div> -->
              </div>
              <div v-if="showCountryDailyTable && showDaySplit && !splitByStatus">
                <datatable tableId="dailyCountryCountList" :columns="dailyCountryColumns"
                  :data="filteredCountsCountry || []" :scrollX="true" :compact="true"
                  @exportCSV="(data) => exportCSV('Tag_day_country_counts', data)" :enableCSVExport="true"
                  :showLoading="filteredCountsCountry === null" />
              </div>
              <div v-if="showsplitByStatusTable && showDaySplit && splitByStatus">
                <complexHeaderDatatable :key="dailyCountryStatusColumns.length" tableId="dailyCountrySplitCountList"
                  :columns="dailyCountryStatusColumns" :scrollX="true" :data="filteredSplitByStatusCount" @exportCSV="
                    (data) => exportCSV('Tag_day_country_counts_by_status', data)
                  " :enableCSVExport="true" :showLoading="filteredSplitByStatusCount === null" />
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:lowLatency>
        <div class="row class-menu mt-4">
          <div class="col-md-12">
            <div class="mb-2">Choose a Class</div>
            <button style="margin-right:10px" key="all" @click="currentClsLL = null" class="btn card-header-title "
              :class="[!currentClsLL ? 'active btn-primary' : 'btn-secondary']">
              All
            </button>
            <button style="margin-right:10px" v-for="classItem in classItems"
              :key="classItem.cls == 'NA' ? 'default' : classItem.cls" @click="currentClsLL = classItem.cls"
              class="btn card-header-title "
              :class="[currentClsLL == classItem.cls ? 'active btn-primary' : 'btn-secondary']">
              {{ classItem.cls == "NA" ? "default" : classItem.cls }}
            </button>
          </div>
        </div>
        <div class="card">
          <!-- The reporting switch is a client setting, so it lives apart from the view filters -->
          <div class="card-header">
            <h4 class="card-header-title">Tag Deployment Visibility</h4>
            <div class="d-flex align-items-center gap-3">
              <small v-if="lowLatencyEnabled && lowLatencyActiveUntilLabel"
                :class="lowLatencyActiveUntilPassed ? 'll-active-until-expired' : 'text-muted'">
                <template v-if="lowLatencyActiveUntilPassed">
                  <span class="fa fa-exclamation-triangle me-1" style="font-size: 12px;"></span>
                  Expired on {{ lowLatencyActiveUntilLabel }}
                </template>
                <template v-else>Active until {{ lowLatencyActiveUntilLabel }}</template>
              </small>
              <small v-if="lowLatencySelectedIsNonProd" class="text-muted">
                <span class="fa fa-lock me-1" style="font-size: 12px;"></span>
                Reporting can only be enabled on the production version.
                <button type="button" class="btn btn-link p-0 ll-switch-to-prod" @click="selectProductionVersion">
                  Switch to {{ lowLatencyProdVersion }}
                </button>
              </small>
              <!-- Reporting only ever runs on the production version, so the switch is off-limits while another is selected.
                   The title sits on the wrapper because a disabled input doesn't fire hover events. -->
              <div class="form-check form-switch mb-0" :title="lowLatencyNonProdHint">
                <!-- click.prevent: the switch only flips once the change is confirmed and saved -->
                <input class="form-check-input" type="checkbox" role="switch" id="llEnableReporting"
                  :checked="lowLatencyEnabled"
                  :disabled="lowLatencyToggling || !lowLatencyConfigured || lowLatencySelectedIsNonProd"
                  @click.prevent="confirmToggleLowLatency" />
                <label class="form-check-label" for="llEnableReporting">Reporting</label>
              </div>
              <span v-if="lowLatencyToggling" class="spinner-border spinner-border-sm text-muted" role="status">
                <span class="visually-hidden">Saving...</span>
              </span>
            </div>
          </div>
          <div class="card-body">
            <!-- align-items-end puts every control on the inputs' baseline, below their labels -->
            <div class="d-flex flex-wrap align-items-end gap-3 mb-5 ll-filters">
              <!-- A dropdown rather than a <select>, since native options can't render the status badges -->
              <div class="dropdown ll-version">
                <label for="llversiondim" class="form-label">Version</label>
                <button type="button" id="llversiondim" class="form-select form-select-sm text-start ll-version-toggle"
                  data-bs-toggle="dropdown" aria-expanded="false"
                  :disabled="!lowLatencyVersionDimensionOptions?.length">
                  <template v-if="lowLatencySelectedOption">
                    <span class="ll-version-name">{{ lowLatencySelectedOption.version }}</span>
                    <span class="ll-version-dims">{{ lowLatencySelectedOption.dims }}</span>
                    <span v-if="lowLatencyVersionBadge(lowLatencySelectedOption.version)" class="badge"
                      :class="lowLatencyVersionBadge(lowLatencySelectedOption.version).cls">
                      {{ lowLatencyVersionBadge(lowLatencySelectedOption.version).label }}
                    </span>
                  </template>
                  <span v-else class="text-muted">{{ lowLatencyVersionDimension || 'Select version' }}</span>
                </button>
                <ul class="dropdown-menu ll-version-menu" aria-labelledby="llversiondim">
                  <li v-for="option in lowLatencyVersionDimensionOptions" :key="option.version">
                    <button type="button" class="dropdown-item ll-version-item"
                      :class="{ selected: option.value === lowLatencyVersionDimension }"
                      @click="selectLowLatencyVersion(option)">
                      <span class="ll-version-check"><i v-if="option.value === lowLatencyVersionDimension"
                          class="fa fa-check"></i></span>
                      <span class="ll-version-name">{{ option.version }}</span>
                      <span class="ll-version-dims">{{ option.dims }}</span>
                      <span v-if="lowLatencyVersionBadge(option.version)" class="badge"
                        :class="lowLatencyVersionBadge(option.version).cls">
                        {{ lowLatencyVersionBadge(option.version).label }}
                      </span>
                    </button>
                  </li>
                </ul>
                <small v-if="lowLatencyVersionHelp" class="ll-version-help" :class="lowLatencyVersionHelp.cls">
                  <i :class="[lowLatencyVersionHelp.icon, 'me-1']"></i>
                  {{ lowLatencyVersionHelp.text }}
                </small>
              </div>
              <div>
                <label for="llstartTime" class="form-label">Start Time</label>
                <flat-pickr :config="timeConfigLL" class="flatpickr-alt-input form-control form-control-sm"
                  placeholder="Select Start Time" name="date" v-model="startTimeLL" id="llstartTime" />
              </div>
              <div>
                <label for="llendTime" class="form-label">End Time</label>
                <flat-pickr :config="timeConfigLL" class="flatpickr-alt-input form-control form-control-sm"
                  placeholder="Select End Time" name="date" v-model="endTimeLL" id="llendTime" />
              </div>
              <div class="ll-presets" role="group" aria-label="Quick time ranges">
                <button v-for="hours in lowLatencyPresets" :key="hours" type="button" class="btn"
                  :class="{ active: lowLatencyPreset === hours }" :aria-pressed="lowLatencyPreset === hours"
                  @click="applyLowLatencyPreset(hours)">
                  Last {{ hours }}h
                </button>
              </div>
              <div class="ms-auto d-flex align-items-center gap-3">
                <small v-if="lowLatencyNextRefreshAt" class="text-muted">
                  Next update at {{ formatLowLatencyTime(lowLatencyNextRefreshAt, 'HH:mm') }}
                </small>
                <!-- Range and preset changes still reload a non-production version; only the explicit Refresh is held back -->
                <span :title="lowLatencyRefreshHint">
                  <button class="btn btn-sm btn-primary" @click="refreshLowLatencyData"
                    :disabled="lowLatencyRefreshing || !lowLatencyConfigured || lowLatencySelectedIsNonProd || lowLatencyCoolingDown">
                    <i :class="['fa fa-refresh', lowLatencyRefreshing ? 'fa-spin' : '']"
                      style="margin-right: 0.3rem;"></i>
                    <span>Refresh</span>
                  </button>
                </span>
              </div>
            </div>
            <!-- Reporting always runs on the production version, so flag a selection that isn't deployed yet -->
            <div v-if="lowLatencySelectedIsUndeployed" class="ll-notice mb-4" role="status">
              <i class="fa fa-circle-info ll-notice-icon"></i>
              <div>
                <div class="ll-notice-title">Version {{ lowLatencyVersion }} hasn't been deployed to production yet
                </div>
                <div class="ll-notice-body">
                  It's the latest version, but reporting runs on version {{ lowLatencyProdVersion }} (production) until
                  you
                  activate it in <router-link :to="`/${cid}/aut/settings`">aUT Settings</router-link>.
                </div>
              </div>
            </div>

            <div v-if="lowLatencyLoading || lowLatencyRefreshing" class="text-center py-5 ll-loading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <div v-else-if="lowLatencyError"
              class="alert alert-danger d-flex justify-content-between align-items-center">
              <span>Couldn't load the report: {{ lowLatencyError }}</span>
            </div>
            <div v-else-if="!lowLatencyConfigured" class="text-center text-muted py-5">
              Tag deployment visibility isn't configured for this client. Set it up in
              <router-link :to="`/${cid}/aut/settings`">aUT Settings</router-link>.
            </div>
            <CollapsibleTable v-else-if="lowLatencyDataFiltered && lowLatencyDataFiltered.length" id="lowLatencyTable"
              :data="lowLatencyDataFiltered" :columns="lowLatencyColumns" :groupBy="groupByColumns"
              :collapsibleCol="collapsibleCol" aggregateCol="count" />
            <div v-else-if="lowLatencyDataFiltered" class="text-center text-muted py-5">
              <p class="mb-1">
                No events for {{ lowLatencyClassLabel }} between
                {{ formatLowLatencyTime(startTimeLL) }} and {{ formatLowLatencyTime(endTimeLL) }}.
              </p>
              <p v-if="!lowLatencyEnabled" class="mb-0 small">Reporting is off. Turn it on above to start collecting
                data.</p>
              <p v-else class="mb-0 small">Try a wider time range or a different class.</p>
            </div>
          </div>
        </div>
      </template>
    </Tabs>
  </div>
</template>

<script>
import BasicHeader from "../../components/BasicHeader.vue";
import axios from "axios";
import { mapActions, mapState } from "vuex";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import Tabs from "../../components/Tabs.vue";
import CollapsibleTable from "../../components/CollapsibleTable.vue";
import InputField from "../../components/InputField.vue";
import Datatable from "../../components/Datatable.vue";
import complexHeaderDatatable from "../../components/ComplexHeaderDatatable";
import csv from "../../utils/tools/csv";
import flatPickr from 'vue-flatpickr-component';
import {
  sortKeysRecursively,
  getCountsData,
  generateDayAndHourAndRawMetricsTimeRanges,
} from "../../utils/counts";
dayjs.extend(customParseFormat);

const LOW_LATENCY_DEFAULT_PRESET = 2;
// The backend updates the report every 5 minutes, so fetching more often returns nothing new
const LOW_LATENCY_REFRESH_MS = 5 * 60 * 1000;

// Second precision so a Date we set and the string flatpickr emits back compare equal
function lowLatencyPresetRange(hours) {
  const end = dayjs().startOf('second');
  let start = end.subtract(hours, 'hour');
  // The picker's minDate is 24h ago; anything earlier would be dropped by flatpickr
  if (hours >= 24) start = start.add(1, 'minute');
  return { start: start.toDate(), end: end.toDate() };
}

function lowLatencyRangeKey(start, end) {
  return `${dayjs(start).valueOf()}|${dayjs(end).valueOf()}`;
}


export default {
  components: {
    BasicHeader,
    InputField,
    Datatable,
    complexHeaderDatatable,
    Tabs,
    CollapsibleTable,
    flatPickr
  },
  data() {
    const initialLowLatencyRange = lowLatencyPresetRange(LOW_LATENCY_DEFAULT_PRESET);
    return {
      currentCls: null,
      currentClsLL: null,
      selectedCountry: "All:All",
      selectedTag: "All:All",
      splitByStatus: false,
      showDaySplitTable: false,
      showsplitByTable: false,
      showsplitByStatusTable: false,
      showCountryListTable: false,
      showCountryDailyTable: false,
      reportOptions: [
        { label: "Tag Type", value: "tag_type" },
        { label: "Country", value: "country" },
      ],
      reportType: "tag_type",
      dateOptions: [
        {
          label: "Today(" + dayjs().format("YYYY-MM-DD") + ")",
          value: "today",
        },
        {
          label: "Yesterday(" + dayjs().subtract(1, "day").format("YYYY-MM-DD") + ")",
          value: "yesterday",
        },
        { label: "Custom Range", value: "custom" },
      ],
      config: {
        wrap: true,
        enableTime: true,
        dateFormat: "m-d-Y H",
        time_24hr: true,
      },
      dateType: "yesterday",
      today: dayjs().format("YYYYMMDD"),
      yesterday: dayjs().subtract(1, "day").format("YYYYMMDD"),
      startDate: dayjs().subtract(1, "day").hour(0).format("MM-DD-YYYY HH"),
      endDate: dayjs().subtract(1, "day").hour(23).format("MM-DD-YYYY HH"),
      startTime: dayjs().hour(0).format("HH"),
      endTime: dayjs().hour(23).format("HH"),
      tagColumns: [
        {
          data: "tagType",
          title: "Tag Type",
        },
        {
          data: "count",
          title: "Count",
        },
      ],
      tagDailyColumns: [],
      partnerDailyColumns: [],
      directDailyColumns: [],
      partnerColumns: [
        {
          data: "beaconId",
          title: "Beacon Id",
        },
        {
          data: "description",
          title: "Description",
        },
        {
          data: "partnerDomain",
          title: "Partner Domain",
        },
        {
          data: "count",
          title: "count",
        },
      ],
      directColumns: [
        {
          data: "partnerDomain",
          title: "Redirect Domain",
        },
        {
          data: "count",
          title: "Count",
        },
      ],
      countryColumns: [],
      dailyCountryColumns: [],
      dailyCountryStatusColumns: [],
      showDaySplit: false,
      threshold_tagType: 1000,
      threshold_partnerBeacon: 1000,
      threshold_redirect: 1000,
      threshold_country: 1000,
      countsPixel: [],
      countsPartnerBeacon: [],
      countsRedirectPixel: [],
      countsCountry: [],
      filteredCountsPixel: null,
      filteredCountsPartnerBeacon: null,
      filteredCountsRedirectPixel: null,
      filteredCountsCountry: null,
      filteredSplitByStatusCount: null,
      counts: {},
      dailyTagColumns: [],
      tagTypesUnique: [],
      countriesUnique: [],
      splitByStatusCounts: [],
      errMode: false,
      errMsg: "",
      countryDataWarning: false,
      tabItems: [
        {
          name: "Tag Reports",
          id: "id1",
          slot: "tagReport",
        },
        {
          name: "Tag Deployment Visibility",
          id: "id2",
          slot: "lowLatency",
          tooltip: "Report is updated every 5 minutes (when enabled) and displays data for the current day",
          helpLink: { url: "https://help.aqfer.net/new-aqfer-aut-developers-guide/tag-deployment-visibility-in-aut", label: "To learn more" },
        },
      ],
      lowLatencyData: null,
      lowLatencyDataFiltered: null,
      lowLatencyColumns: [
        { data: "time", title: "time" },
        { data: "count", title: "count" },
      ],
      groupByColumns: [],
      collapsibleCol: '',
      lowLatencyRefreshing: false,
      lowLatencyLoading: true, // until the first getLowLatencyData settles
      lowLatencyError: null,
      lowLatencyLastUpdated: null,
      lowLatencyToggling: false,
      lowLatencyRequestId: 0,
      lowLatencyFetchedKey: null,
      lowLatencyReloadTimer: null,
      lowLatencyAutoTimer: null,
      lowLatencyNextRefreshAt: null,
      lowLatencyCooldownUntil: null,
      lowLatencyCooldownTimer: null,
      lowLatencyAutoRunning: false,
      lowLatencyPresets: [1, 2, 6, 24],
      lowLatencyPreset: LOW_LATENCY_DEFAULT_PRESET,
      lowLatencyPresetKey: lowLatencyRangeKey(initialLowLatencyRange.start, initialLowLatencyRange.end),
      lowLatencyEnabled: null,
      lowLatencyVersion: null,
      lowLatencyDimensions: null,
      lowLatencyVersionDimension: null,
      lowLatencyVersionDimensionOptions: null,
      excludeDims: new Set(["batch_id", "cid", "class", "version"]),
      currentTime: new Date(),
      startTimeLL: initialLowLatencyRange.start,
      endTimeLL: initialLowLatencyRange.end,
    };
  },
  async beforeMount() {
    // Staging config only labels the version dropdown, so the report doesn't wait on it
    this.$store.dispatch("aut/fetchAutClientData", this.cid);
    await this.$store.dispatch("aut/fetchAutProdClientData", this.cid).then(() => {
      this.initiateClass();
      this.loadCounts();
      if (this.clientData && this.clientData.lowLatencyCountsConfig && this.clientData.lowLatencyCountsConfig.metricName)
        this.getLLMetrics(this.clientData.lowLatencyCountsConfig.metricName);
      this.getLowLatencyData(false);
    }).catch((error) => {
      this.lowLatencyLoading = false;
      this.lowLatencyError = error?.response?.data?.error || error?.message || "Couldn't load the client's aUT settings";
    });
  },
  async mounted() {
    this.intervalId = setInterval(() => {
      this.currentTime = new Date()
    }, 60 * 1000); // update max time configurable for low latency every minute
    document.addEventListener("visibilitychange", this.onLowLatencyVisibilityChange);
  },
  beforeUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    clearTimeout(this.lowLatencyReloadTimer);
    this.clearLowLatencyAutoRefresh();
    clearTimeout(this.lowLatencyCooldownTimer);
    document.removeEventListener("visibilitychange", this.onLowLatencyVisibilityChange);
  },
  computed: {
    ...mapState({
      cid: (state) => state.currentClient.cid,
      clientData: (state) => state.aut.autProdClientData,
      stagingClientData: (state) => state.aut.autClientData,
      classItems: (state) => state.aut.autProdClientData?.classes?.items || [],
    }),
    timeConfigLL() {
      const now = new Date(this.currentTime);
      let minDate = new Date(now);
      minDate.setDate(minDate.getDate() - 1); // set minimum start time to 24 hrs ago
      return {
        wrap: true,
        enableTime: true,
        enableSeconds: true,
        dateFormat: 'Y-m-d H:i:S',
        altFormat: 'm-d-Y H',
        altInput: true,
        // Set explicitly: otherwise flatpickr snapshots the input's classes once at creation,
        // so a later class change (or a hot reload) never reaches the visible field
        altInputClass: 'flatpickr-alt-input form-control form-control-sm',
        time_24hr: true,
        minDate: minDate,
        maxDate: now.setSeconds(now.getSeconds() + 1),
      }
    },
    // Reporting always runs on the version in the production config; staging holds saved-but-undeployed changes
    lowLatencyProdVersion() {
      const v = this.clientData?.lowLatencyCountsConfig?.metricVersion;
      return v ? String(v) : null;
    },
    lowLatencyStagingVersion() {
      const v = this.stagingClientData?.lowLatencyCountsConfig?.metricVersion;
      return v ? String(v) : null;
    },
    lowLatencyStagingPending() {
      return !!this.lowLatencyStagingVersion && this.lowLatencyStagingVersion !== this.lowLatencyProdVersion;
    },
    lowLatencySelectedIsProd() {
      return !!this.lowLatencyVersion && String(this.lowLatencyVersion) === this.lowLatencyProdVersion;
    },
    // Only when a production version is known, so a client without one isn't locked out
    lowLatencySelectedIsNonProd() {
      return !!this.lowLatencyProdVersion && !!this.lowLatencyVersion && !this.lowLatencySelectedIsProd;
    },
    lowLatencyNonProdHint() {
      return this.lowLatencySelectedIsNonProd
        ? `Select the production version (${this.lowLatencyProdVersion}) to use this`
        : null;
    },
    // An older version is superseded rather than waiting on a deploy, so it reads as history, not as pending
    lowLatencyVersionHelp() {
      if (!this.lowLatencyVersion || !this.lowLatencyProdVersion) return null;
      if (this.lowLatencySelectedIsProd) return { cls: "is-deployed", icon: "fa fa-circle-check", text: "Deployed to production" };
      if (this.lowLatencySelectedIsUndeployed) return { cls: "is-pending", icon: "fa fa-circle-exclamation", text: "Not yet deployed to production" };
      return { cls: "is-previous", icon: "fa fa-clock-rotate-left", text: "Older version" };
    },
    lowLatencySelectedOption() {
      return (this.lowLatencyVersionDimensionOptions || []).find((o) => o.value === this.lowLatencyVersionDimension) || null;
    },
    lowLatencySelectedIsUndeployed() {
      return this.lowLatencyStagingPending && String(this.lowLatencyVersion) === this.lowLatencyStagingVersion;
    },
    lowLatencyConfigured() {
      return !!this.clientData?.lowLatencyCountsConfig?.metricName;
    },
    lowLatencyActiveUntilLabel() {
      const until = this.clientData?.lowLatencyCountsConfig?.activatedUntil;
      if (!until) return null;
      const parsed = dayjs(until);
      return parsed.isValid() ? parsed.format('MMM D, YYYY HH:mm') : until;
    },
    // Reads currentTime (ticked every minute) so the label flips to "Expired" without a reload
    lowLatencyActiveUntilPassed() {
      const until = dayjs(this.clientData?.lowLatencyCountsConfig?.activatedUntil);
      return until.isValid() && until.isBefore(dayjs(this.currentTime));
    },
    // A fetch the user caused is as fresh as the report gets for the next cycle; after a failure, retrying stays open.
    // Cleared by its own timer rather than the minute tick, so the button enables at the time the hint names
    lowLatencyCoolingDown() {
      return !!this.lowLatencyCooldownUntil && !this.lowLatencyError;
    },
    lowLatencyRefreshHint() {
      if (this.lowLatencyNonProdHint) return this.lowLatencyNonProdHint;
      if (!this.lowLatencyCoolingDown) return null;
      const next = new Date(this.lowLatencyCooldownUntil);
      return `The report updates every 5 minutes. Refresh is available again at ${this.formatLowLatencyTime(next, 'HH:mm')}`;
    },
    lowLatencyRangeError() {
      if (!this.startTimeLL || !this.endTimeLL) return 'Select a start and end time.';
      if (!dayjs(this.startTimeLL).isBefore(dayjs(this.endTimeLL))) return 'Start time must be before end time.';
      return null;
    },
    lowLatencyClassLabel() {
      if (!this.currentClsLL) return 'any class';
      return this.currentClsLL == 'NA' ? 'the default class' : `class "${this.currentClsLL}"`;
    },
  },
  watch: {
    dateType() {
      this.loadCounts();
    },
    currentCls() {
      this.loadCounts();
    },
    reportType() {
      this.loadCounts();
    },
    currentClsLL() {
      this.filterLLDataByClass();
    },
    // Every successful fetch, auto, manual or a range change, restarts the 5-minute cycle
    lowLatencyLastUpdated() {
      this.scheduleLowLatencyAutoRefresh();
    },
    startTimeLL() {
      this.onLowLatencyRangeChange();
    },
    endTimeLL() {
      this.onLowLatencyRangeChange();
    },
    showDaySplit(val) {
      this.loadCounts();
    },
    splitByStatus(val) {
      this.showSplitByStatus(val);
    },
    selectedCountry(val) {
      this.filterDailyCountsCountryTT(this.selectedTag, this.selectedCountry);
    },
    selectedTag(val) {
      this.filterDailyCountsCountryTT(this.selectedTag, this.selectedCountry);
    },
    threshold_country(val) {
      if (!this.showDaySplit) {
        this.filteredCountsCountry = this.countsCountry.filter((obj) => {
          return obj.total > val;
        });
      } else {
        this.filteredCountsCountry = this.countriesUnique.filter((obj) => {
          return obj.count > val;
        });
      }
    },
    threshold_tagType(val) {
      if (!this.showDaySplit) {
        this.filteredCountsPixel = this.countsPixel.filter((obj) => {
          return obj.count > val;
        });
      } else {
        this.filteredCountsPixel = this.tagTypesUnique.filter((obj) => {
          return obj.count > this.threshold_tagType;
        });
      }
    },
    threshold_partnerBeacon(val) {
      if (!this.showDaySplit) {
        this.filteredCountsPartnerBeacon = this.countsPartnerBeacon.filter((obj) => {
          return obj.count > val;
        });
      } else {
        this.filteredCountsPartnerBeacon = this.partnerDomainsUnique.filter((obj) => {
          return obj.count > this.threshold_partnerBeacon && obj.beaconId != "All";
        });
      }
    },
    threshold_redirect(val) {
      if (!this.showDaySplit) {
        this.filteredCountsRedirectPixel = this.countsRedirectPixel.filter((obj) => {
          return obj.count > val;
        });
      } else {
        this.filteredCountsRedirectPixel = this.redirectDomainsUnique.filter((obj) => {
          return obj.count > this.threshold_redirect;
        });
      }
    },
  },
  methods: {
    ...mapActions({
      getMetricMetadata: "aut/getMetricMetadata",
      showModal: "showModal",
      addToast: "addToast",
    }),
    formatLowLatencyTime(value, format = 'MMM D, HH:mm') {
      return value ? dayjs(value).format(format) : '';
    },
    // Production, or Staging only while it differs from production
    lowLatencyVersionBadge(version) {
      const v = String(version);
      if (v === this.lowLatencyProdVersion) return { label: "Production", cls: "bg-primary" };
      if (this.lowLatencyStagingPending && v === this.lowLatencyStagingVersion) return { label: "Staging", cls: "bg-warning" };
      return null;
    },
    selectProductionVersion() {
      const option = (this.lowLatencyVersionDimensionOptions || []).find((o) => String(o.version) === this.lowLatencyProdVersion);
      if (option) this.selectLowLatencyVersion(option);
    },
    selectLowLatencyVersion(option) {
      if (option.value === this.lowLatencyVersionDimension) return;
      this.lowLatencyVersionDimension = option.value;
      this.onLowLatencyVersionChange(option.value);
    },
    // Confirm.vue renders its message as HTML, so anything from the API gets escaped first
    escapeHtml(value) {
      return String(value ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
    },
    onLowLatencyVersionChange(val) {
      this.handleLowLatencyVersionChange(val);
      this.scheduleLowLatencyReload();
    },
    onLowLatencyRangeChange() {
      // A hand-picked time no longer matches the preset window, so drop its highlight
      if (this.lowLatencyPreset && lowLatencyRangeKey(this.startTimeLL, this.endTimeLL) !== this.lowLatencyPresetKey) {
        this.lowLatencyPreset = null;
      }
      this.scheduleLowLatencyReload();
    },
    async applyLowLatencyPreset(hours) {
      // Move the picker's maxDate up to now first, or flatpickr rejects the new end time
      this.currentTime = new Date();
      await this.$nextTick();
      const { start, end } = lowLatencyPresetRange(hours);
      this.lowLatencyPreset = hours;
      this.lowLatencyPresetKey = lowLatencyRangeKey(start, end);
      this.startTimeLL = start;
      this.endTimeLL = end;
    },
    lowLatencyQueryKey() {
      const dims = (this.lowLatencyDimensions || []).join(',');
      return `${this.lowLatencyVersion}|${dims}|${lowLatencyRangeKey(this.startTimeLL, this.endTimeLL)}`;
    },
    // Debounced, and skipped when nothing changed: flatpickr re-emits each value as a formatted string
    scheduleLowLatencyReload() {
      clearTimeout(this.lowLatencyReloadTimer);
      this.lowLatencyReloadTimer = setTimeout(() => {
        // Not loaded yet: the initial getLowLatencyData(false) call covers it
        if (!this.lowLatencyVersion) return;
        // A refresh in progress fetches with the final range itself
        if (this.lowLatencyRefreshing) return;
        if (this.lowLatencyRangeError) {
          this.addToast({ type: "error", message: this.lowLatencyRangeError });
          return;
        }
        if (this.lowLatencyQueryKey() === this.lowLatencyFetchedKey) return;
        this.getLowLatencyData(true);
      }, 400);
    },
    handleLowLatencyVersionChange(val) {
      let arr = val.split(" - ")
      if (arr.length != 2) return;
      this.lowLatencyVersion = arr[0];
      this.lowLatencyDimensions = arr[1].split(", ");
    },
    async getLLMetrics(metric) {
      // Built aside and swapped in, so a refresh doesn't blank the dropdown while it loads
      const options = [];
      if (!this.lowLatencyVersionDimensionOptions) this.lowLatencyVersionDimensionOptions = [];
      await this.getMetricMetadata(metric).then((response) => {
        if (response?.data) {
          const versions = response.data[metric].versions;
          // for each version
          Object.entries(versions).forEach(([key, value]) => {
            let dims = value.dimensions.filter((dim) => {
              // filter some default dims
              return !this.excludeDims.has(dim.name)
            }).map(dim => dim.name).join(", ")
            options.push({
              version: key,
              label: `${key} - [${dims}]`,
              dims,
              value: `${key} - ${dims}`,
            })
          });
        }
        this.lowLatencyVersionDimensionOptions = options;
      }).catch((error) => {
        let err = error.response?.data.error ? error.response.data.error : error.message;
        console.error("Error getting low latency metric metadata: ", err)
      })
    },
    filterLLDataByClass() {
      if (!this.lowLatencyData) return;
      if (!this.currentClsLL) {
        this.lowLatencyDataFiltered = [...this.lowLatencyData];
        return;
      }
      this.lowLatencyDataFiltered = this.lowLatencyData.filter(item => item.class === this.currentClsLL)
    },
    getLowLatencyData(customVersion) {
      const llConfig = this.clientData?.lowLatencyCountsConfig;
      this.lowLatencyEnabled = !!llConfig?.activatedUntil;
      const version = customVersion ? this.lowLatencyVersion : llConfig?.metricVersion
      const metric = llConfig?.metricName;
      const dimensions = customVersion ? this.lowLatencyDimensions : llConfig?.dimensions
      if (!version || !metric || !dimensions || dimensions.length == 0) {
        this.lowLatencyData = [];
        this.lowLatencyDataFiltered = [];
        this.lowLatencyLoading = false;
        return Promise.resolve();
      }

      if (!customVersion) {
        let dimsStr = dimensions.join(", ");
        this.lowLatencyVersionDimension = `${version} - ${dimsStr}`
        this.handleLowLatencyVersionChange(this.lowLatencyVersionDimension)
      }
      if (this.lowLatencyRangeError) {
        this.lowLatencyLoading = false;
        return Promise.resolve();
      }

      // dimensions go between class and time in both the request and the displayed columns
      const headers = ["class", ...dimensions, "time", "count"];
      this.lowLatencyColumns = [
        ...dimensions.map((dim) => ({ data: dim, title: dim })),
        { data: "time", title: "time" },
        { data: "count", title: "count" },
      ];
      this.groupByColumns = [...dimensions];
      this.collapsibleCol = dimensions[0];

      const startTimeUTC = dayjs(this.startTimeLL).utc().format('YYYY-MM-DD HH:mm:ss')
      const endTimeUTC = dayjs(this.endTimeLL).utc().format('YYYY-MM-DD HH:mm:ss')
      this.lowLatencyFetchedKey = this.lowLatencyQueryKey();

      // A slower, older response must not overwrite a newer range's data
      const requestId = ++this.lowLatencyRequestId;
      this.lowLatencyLoading = true;
      this.lowLatencyError = null;
      this.lowLatencyData = null;
      this.lowLatencyDataFiltered = null;

      let countsPayload = {
        start_time: startTimeUTC,
        end_time: endTimeUTC,
        aggregate: true,
        filter_dimensions: {
          version: version,
        },
        metrics: {
          [metric]: {
            version: version,
            header: headers,
          },
        },
      };
      return axios
        .post(
          `${this.$store.state.countsUrl}/v2/cids/${this.cid}/metrics/batch/query`,
          countsPayload,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.accessToken}`,
            },
            // The global interceptor resolves network errors as undefined; reject so they reach the catch
            errorHandle: false,
          }
        )
        .then((response) => {
          if (requestId !== this.lowLatencyRequestId) return;
          const data = response.data?.data?.[metric];
          this.lowLatencyData = (data?.data || []).map((row) =>
            Object.fromEntries(data.headers.map((header, i) => [header, row[i]]))
          );
          this.lowLatencyLastUpdated = new Date();
          if (!this.lowLatencyAutoRunning) this.startLowLatencyCooldown();
          this.filterLLDataByClass();
        })
        .catch((error) => {
          if (requestId !== this.lowLatencyRequestId) return;
          this.lowLatencyError = error.response?.data?.error || error.message || 'Request failed';
        })
        .finally(() => {
          if (requestId === this.lowLatencyRequestId) this.lowLatencyLoading = false;
        });
    },
    // lowLatencyRefreshing holds the spinner until both configs and the counts are back,
    // and keeps the range watcher from firing its own fetch alongside this one
    async refreshLowLatencyData() {
      if (this.lowLatencyRefreshing) return;
      this.lowLatencyRefreshing = true;
      try {
        // With a preset selected, Refresh rolls the window forward to now
        if (this.lowLatencyPreset) await this.applyLowLatencyPreset(this.lowLatencyPreset);
        // Re-read both configs so the switch and the version labels reflect what's saved and deployed
        await Promise.all([
          this.$store.dispatch("aut/fetchAutProdClientData", this.cid),
          this.$store.dispatch("aut/fetchAutClientData", this.cid),
        ]);
        // A dimension change in Settings creates a new version, so reload the list the badges are matched against
        const metric = this.clientData?.lowLatencyCountsConfig?.metricName;
        if (metric) await this.getLLMetrics(metric);
        clearTimeout(this.lowLatencyReloadTimer);
        await this.getLowLatencyData(true);
      } finally {
        this.lowLatencyRefreshing = false;
      }
    },
    // The production version's card for the confirm modal: version, badge, and its dimensions as chips
    lowLatencyProdCardHtml(caption) {
      const version = this.lowLatencyProdVersion;
      if (!version) return "";
      const dims = this.clientData?.lowLatencyCountsConfig?.dimensions || [];
      const chips = dims.length
        ? `<div class="ll-confirm-label">Dimensions</div>` +
          `<div class="ll-confirm-chips">${dims.map((d) => `<span class="ll-confirm-chip">${this.escapeHtml(d)}</span>`).join("")}</div>`
        : "";
      return `<div class="ll-confirm-card">` +
        `<div class="ll-confirm-card-head"><span class="ll-confirm-label mb-0">${caption}</span>` +
        `<span class="badge bg-primary">Production</span></div>` +
        `<div class="ll-confirm-version">${this.escapeHtml(version)}</div>${chips}</div>`;
    },
    // Reached only with the production version selected; the switch is disabled for any other
    confirmToggleLowLatency() {
      const enable = !this.lowLatencyEnabled;
      const self = this;
      const fact = (icon, text) => `<li><i class="fa ${icon}"></i><span>${text}</span></li>`;
      const message = `<div class="ll-confirm">` +
        `<div class="ll-confirm-hero ${enable ? "is-on" : "is-off"}">` +
          `<span class="ll-confirm-hero-icon"><i class="fa ${enable ? "fa-chart-line" : "fa-pause"}"></i></span>` +
          `<div><div class="ll-confirm-hero-title">${enable ? "Start collecting tag events" : "Stop collecting tag events"}</div>` +
          `<div class="ll-confirm-hero-sub">${enable
            ? "Reporting runs on the version deployed to production."
            : "Events collected so far stay available in the report."}</div></div>` +
        `</div>` +
        this.lowLatencyProdCardHtml(enable ? "Reporting will use" : "Currently reporting on") +
        `<ul class="ll-confirm-facts">` +
          (enable
            ? fact("fa-clock-rotate-left", "The report updates every 5 minutes")
            : fact("fa-ban", "The report stops updating")) +
        `</ul></div>`;
      this.showModal({
        component: "confirm",
        data: {
          title: enable ? "Turn on tag deployment visibility?" : "Turn off tag deployment visibility?",
          message,
          confirmText: enable ? "Turn on" : "Turn off",
          confirmClass: enable ? "btn-primary" : "btn-danger",
          confirm() {
            return self.updateLowLatencyEnabled(enable);
          },
        },
      });
    },
    // The switch is bound one-way, so a failed save leaves it on the last saved state
    async updateLowLatencyEnabled(enabled) {
      this.lowLatencyToggling = true;
      try {
        await axios.put(
          `${this.$store.state.autMgmtUrl}/v1/clients/${this.$store.state.currentClient.cid}/low_latency_counts/enabled/${enabled}`, {},
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.accessToken}`,
            },
            errorHandle: false,
          }
        );
      } catch (error) {
        const err = error.response?.data?.error || error.message;
        this.addToast({ type: "error", message: `Couldn't turn reporting ${enabled ? "on" : "off"}: ${err}` });
        return;
      } finally {
        this.lowLatencyToggling = false;
      }
      this.lowLatencyEnabled = enabled;
      this.addToast({ type: "success", message: `Tag deployment visibility turned ${enabled ? "on" : "off"}.` });
      if (!enabled) {
        this.clearLowLatencyAutoRefresh();
        return;
      }
      // Nothing is collected until the first 5-minute update, so the counts wait a cycle; only the config is re-read now,
      // for the new "Active until". Not awaited: the confirm modal shouldn't stay open for it.
      this.$store.dispatch("aut/fetchAutProdClientData", this.cid)
        .catch((error) => console.error("Error re-reading aUT settings: ", error?.message))
        .finally(() => this.scheduleLowLatencyAutoRefresh());
    },
    // A method, not a computed: it depends on the clock, which a computed wouldn't track
    isLowLatencyExpired() {
      const until = dayjs(this.clientData?.lowLatencyCountsConfig?.activatedUntil);
      return until.isValid() && until.isBefore(dayjs());
    },
    startLowLatencyCooldown() {
      clearTimeout(this.lowLatencyCooldownTimer);
      this.lowLatencyCooldownUntil = Date.now() + LOW_LATENCY_REFRESH_MS;
      this.lowLatencyCooldownTimer = setTimeout(() => {
        this.lowLatencyCooldownUntil = null;
      }, LOW_LATENCY_REFRESH_MS);
    },
    clearLowLatencyAutoRefresh() {
      clearTimeout(this.lowLatencyAutoTimer);
      this.lowLatencyAutoTimer = null;
      this.lowLatencyNextRefreshAt = null;
    },
    scheduleLowLatencyAutoRefresh() {
      this.clearLowLatencyAutoRefresh();
      if (!this.lowLatencyEnabled || this.isLowLatencyExpired()) return;
      this.lowLatencyNextRefreshAt = new Date(Date.now() + LOW_LATENCY_REFRESH_MS);
      this.lowLatencyAutoTimer = setTimeout(() => this.runLowLatencyAutoRefresh(), LOW_LATENCY_REFRESH_MS);
    },
    async runLowLatencyAutoRefresh() {
      this.lowLatencyAutoTimer = null;
      // Left due: the visibility handler runs it once the tab is back
      if (document.hidden) return;
      // A non-production version collects nothing, and a fixed range that ended over two cycles ago can't gain events,
      // so skip this tick but keep the cycle going for when either changes. A refresh already in flight is skipped too;
      // if it succeeds, the watcher reschedules from it.
      const rangeClosed = !this.lowLatencyPreset &&
        dayjs(this.endTimeLL).isBefore(dayjs().subtract(2 * LOW_LATENCY_REFRESH_MS, 'millisecond'));
      if (this.lowLatencyRefreshing || this.lowLatencySelectedIsNonProd || rangeClosed) {
        this.scheduleLowLatencyAutoRefresh();
        return;
      }
      const lastUpdated = this.lowLatencyLastUpdated;
      // An auto-refresh fires just as the cooldown ends, so it mustn't start a new one or Refresh never enables
      this.lowLatencyAutoRunning = true;
      try {
        await this.refreshLowLatencyData();
      } catch (error) {
        console.error("Error auto-refreshing tag deployment visibility: ", error?.message);
      } finally {
        this.lowLatencyAutoRunning = false;
      }
      // A successful fetch reschedules through the lowLatencyLastUpdated watcher; a failed one retries next cycle
      if (this.lowLatencyLastUpdated === lastUpdated) this.scheduleLowLatencyAutoRefresh();
    },
    onLowLatencyVisibilityChange() {
      if (document.hidden || this.lowLatencyAutoTimer || !this.lowLatencyNextRefreshAt) return;
      if (Date.now() >= this.lowLatencyNextRefreshAt.getTime()) this.runLowLatencyAutoRefresh();
    },
    async loadCounts() {
      let self = this;
      let clsString = "";
      this.errMode = false;
      this.countryDataWarning = false;

      this.filteredCountsPixel = null;
      this.filteredCountsPartnerBeacon = null;
      this.filteredCountsRedirectPixel = null;
      this.filteredCountsCountry = null;
      this.showCountryListTable = false;

      if (this.dateType == "today") {
        this.toDate = this.today;
        this.fromDate = this.today;
      } else if (this.dateType == "yesterday") {
        this.toDate = this.yesterday;
        this.fromDate = this.yesterday;
      } else if (this.dateType == "custom") {
        this.fromDate = dayjs(this.startDate, "MM-DD-YYYY HH", true).format("YYYYMMDD");
        this.startTime = dayjs(this.startDate, "MM-DD-YYYY HH", true).format("HH");
        this.toDate = dayjs(this.endDate, "MM-DD-YYYY HH", true).format("YYYYMMDD");
        this.endTime = dayjs(this.endDate, "MM-DD-YYYY HH", true).format("HH");
      }
      const isCountryReport = this.reportType == "country";
      if (isCountryReport) {
        const earliestSelectedDate =
          this.fromDate < this.toDate ? this.fromDate : this.toDate;
        if (this.dateDiffInDays(earliestSelectedDate, this.today) > 90) {
          this.countryDataWarning = true;
        }
      } else if (this.dateDiffInDays(this.fromDate, this.toDate) > 95) {
        this.errMsg = "Request Denied. Requested date range is more than 3 months.";
        this.errMode = true;
        return "";
      }

      if (this.currentCls) {
        clsString = "/clss/" + this.currentCls;
      }

      if (this.clientData && this.clientData.config.pidCounts == true) {
        this.getPidCounts = true;
      } else {
        this.getPidCounts = false;
      }

      // Daily Counts
      if (this.showDaySplit) {
        // axios
        //   .get(
        //     `${this.$store.state.countsUrl}/v1/latency/cids/${this.cid}${clsString}/from/${this.fromDate}/until/${this.toDate}?daily=true&bg=true`,
        //     {
        //       headers: {
        //         Authorization: `Bearer ${this.$store.state.accessToken}`,
        //       },
        //     }
        //   )
        //   .then(function (response) {
        //     self.watchCountsQuery(
        //       response.data.query_execution_id,
        //       "latency",
        //       30000,
        //       function (response) {
        //         axios
        //           .get(
        //             `${self.$store.state.countsUrl}/v1/latency/cids/${self.cid}${clsString}/from/${self.fromDate}/until/${self.toDate}?daily=true`,
        //             {
        //               headers: {
        //                 Authorization: `Bearer ${self.$store.state.accessToken}`,
        //               },
        //             }
        //           )
        //           .then(function (response) {
        //             self.countsLoadingLatency = false;
        //             self.countriesPBLatency = {};
        //             // Get all column indexes for data row from columnDefs
        //             let cIndex, ccIndex, dIndex, pdIndex, sIndex, tIndex;
        //             for (let i = 0; i < response.data.columnDefs.length; i++) {
        //               switch (response.data.columnDefs[i].name) {
        //                 case "date":
        //                   dIndex = i;
        //                   break;
        //                 case "tag_type":
        //                   tIndex = i;
        //                   break;
        //                 case "country_code":
        //                   ccIndex = i;
        //                   break;
        //                 case "partnerDomain":
        //                   pdIndex = i;
        //                   break;
        //                 case "load_status":
        //                   sIndex = i;
        //                   break;
        //                 case "count":
        //                   cIndex = i;
        //                   break;
        //               }
        //             }
        //             // use above indexes to extract data from array of data rows
        //             for (let i = 0; i < response.data.data.length; i++) {
        //               let obj = response.data.data[i];
        //               let ccode = obj[ccIndex].toUpperCase();
        //               if (
        //                 obj[cIndex].match(/\d+/) != null &&
        //                 obj[tIndex] === "partner_beacon" &&
        //                 !obj[pdIndex].includes("NA:")
        //               ) {
        //                 let count = parseInt(obj[cIndex]);
        //                 let key = obj[dIndex] + obj[pdIndex] + obj[ccIndex] + obj[sIndex];
        //                 let allKey = obj[dIndex] + "All:All" + obj[ccIndex] + obj[sIndex];
        //                 let colTotalKey = obj[dIndex] + obj[pdIndex] + "_" + obj[sIndex];
        //                 let colTotalAllKey = obj[dIndex] + "All:All" + "_" + obj[sIndex];
        //                 let rowTotalKey = obj[dIndex] + obj[pdIndex] + obj[ccIndex] + "_";
        //                 let rowTotalAllKey = obj[dIndex] + "All:All" + obj[ccIndex] + "_";
        //                 let allTotalKey = obj[dIndex] + obj[pdIndex] + "_" + "_";
        //                 let allTotalAllKey = obj[dIndex] + "All:All" + "_" + "_";
        //                 self.updateCountriesPBLatencyCounts(key, count);
        //                 self.updateCountriesPBLatencyCounts(colTotalKey, count);
        //                 self.updateCountriesPBLatencyCounts(rowTotalKey, count);
        //                 self.updateCountriesPBLatencyCounts(allTotalKey, count);
        //                 self.updateCountriesPBLatencyCounts(allKey, count);
        //                 self.updateCountriesPBLatencyCounts(colTotalAllKey, count);
        //                 self.updateCountriesPBLatencyCounts(rowTotalAllKey, count);
        //                 self.updateCountriesPBLatencyCounts(allTotalAllKey, count);
        //               }
        //             }
        //           });
        //       }
        //     );
        //   })
        //   .catch((error) => {
        //     this.errMode = true;
        //     if (error.response.data.error) this.errMsg = error.response.data.error;
        //     else this.errMsg = error.message;
        //   });
        let response;
        try {
          response = await this.aggCounts(
            this.currentCls,
            this.fromDate,
            this.toDate,
            this.startTime,
            this.endTime,
            isCountryReport,
            true
          );
        } catch (error) {
          this.errMode = true;
          if (error.response.data.error) this.errMsg = error.response.data.error;
          else this.errMsg = error.message;
          return;
        }
        self.updateDailyReports(response);
      } else {
        //Counts between given time period
        this.showDaySplitTable = false;
        this.showCountryDailyTable = false;
        let response;

        try {
          response = await this.aggCounts(
            this.currentCls,
            this.fromDate,
            this.toDate,
            this.startTime,
            this.endTime,
            isCountryReport
          );
        } catch (error) {
          this.errMode = true;
          if (error.response.data.error) this.errMsg = error.response.data.error;
          else this.errMsg = error.message;
          return;
        }
        this.updateReports(response);
      }

      // Revisit Code if client data has pidCounts set
      // if (this.getPidCounts && this.reportType != "tagType") {
      //     this.loadPidCount();
      // }
    },
    updateReports(d) {
      let self = this;
      this.countsPartnerBeacon = [];
      this.countsPixel = [];
      this.countsRedirectPixel = [];
      this.countries = [];
      this.countsCountry = [];
      this.countryColumns = [];
      this.countryColumns.push({
        data: "country",
        title: "Country",
      });

      if (d["tagType_countryCode"]) {
        this.countsCountries = d.tagType_countryCode;
      }

      for (let cc in d.countryCode) {
        this.countries.push({
          country: cc,
          count: d.countryCode[cc],
        });
      }
      for (let cData in this.countsCountries) {
        this.countryColumns.push({
          data: cData,
          title: cData,
        });
      }

      for (const country of this.countries) {
        let countryData = {};
        countryData.country = country.country;
        let total = 0;
        for (let cData in this.countsCountries) {
          if (this.countsCountries[cData][country.country]) {
            countryData[cData] = this.countsCountries[cData][country.country];
          } else {
            countryData[cData] = 0;
          }
          total = total + countryData[cData];
        }
        countryData.total = total;
        this.countsCountry.push(countryData);
      }
      this.countryColumns.push({
        data: "total",
        title: "Total",
      });
      this.filteredCountsCountry = this.countsCountry.filter((obj) => {
        return obj.total > self.threshold_country;
      });

      this.appendCounts(d.tagType, this.countsPixel, "tagType");
      this.appendCounts(
        d.partnerBeacon,
        this.countsPartnerBeacon,
        "partnerDomain",
        "beaconId"
      );
      this.appendCounts(
        d.redirect,
        this.countsRedirectPixel,
        "partnerDomain",
        "beaconId"
      );

      this.filteredCountsPixel = this.countsPixel.filter((obj) => {
        return obj.count > this.threshold_tagType;
      });

      this.filteredCountsPartnerBeacon = this.countsPartnerBeacon.filter((obj) => {
        return obj.count > this.threshold_partnerBeacon;
      });

      this.filteredCountsRedirectPixel = this.countsRedirectPixel.filter((obj) => {
        return obj.count > this.threshold_redirect;
      });

      this.showCountryListTable = true;

      this.mergeCounts(this.countsPartnerBeacon, "beaconId", "partnerDomain");
    },

    updateDailyReports(d) {
      let self = this;
      this.showDaySplitTable = false;
      this.showCountryDailyTable = false;
      this.countsPartnerBeaconSP = [];
      this.countsPixelSP = [];
      this.countsRedirectPixelSP = [];
      this.dailyCountsCountries = [];
      this.countsCountriesTTSP = [];
      this.countsCountriesPBSP = [];
      this.tagTypesUnique = [];
      this.partnerDomainsUnique = [
        {
          count: 0,
          partnerDomain: "All",
          beaconId: "All",
        },
      ];

      this.tagDailyColumns = [];
      this.directDailyColumns = [];
      this.partnerDailyColumns = [];
      this.tagDailyColumns.push({
        data: "tagType",
        title: "Tag Type",
      });
      this.partnerDailyColumns.push(
        {
          data: "beaconId",
          title: "Beacon Id",
        },
        {
          data: "description",
          title: "Description",
        },
        {
          data: "partnerDomain",
          title: "Partner Domain",
        }
      );
      this.directDailyColumns.push({
        data: "redirectDomain",
        title: "Redirect Domain",
      });
      this.dailyCountryColumns = [];
      this.dailyCountryColumns.push({
        data: "cc",
        title: "Country",
      });
      this.redirectDomainsUnique = [];
      this.countriesUnique = [];
      var tempTtObj = {};
      var tempPdObj = {};
      var tempRdObj = {};
      var tempCcObj = {};
      for (let day in d) {
        if (this.$store.state.environment === "test" && day.substring(9) != "") {
          continue;
        }
        let dayStr = day.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
        this.tagDailyColumns.push({ data: dayStr, title: dayStr });
        this.partnerDailyColumns.push({ data: dayStr, title: dayStr });
        this.directDailyColumns.push({ data: dayStr, title: dayStr });
        this.dailyCountryColumns.push({ data: dayStr, title: dayStr });
        this.countsPixelSP.push({
          day: dayStr,
          tagType: d[day].tagType,
        });
        this.countsPartnerBeaconSP.push({
          day: dayStr,
          partnerDomain: d[day].partnerBeacon,
        });
        this.countsRedirectPixelSP.push({
          day: dayStr,
          partnerDomain: d[day].redirect,
        });
        this.countsCountriesTTSP.push({
          day: dayStr,
          tagType_cc: d[day].tagType_countryCode,
        });
        this.countsCountriesPBSP.push({
          day: dayStr,
          partnerDomain_cc: d[day].partnerBeacon_countryCode,
        });
        this.transformCounts(d[day].tagType, tempTtObj);
        this.transformCounts(d[day].partnerBeacon, tempPdObj);
        this.transformCounts(d[day].redirect, tempRdObj);
        this.transformCounts(d[day].countryCode, tempCcObj);
      }

      this.tagDailyColumns.push({
        data: "count",
        title: "Count",
      });
      this.partnerDailyColumns.push({
        data: "count",
        title: "Count",
      });
      this.directDailyColumns.push({
        data: "count",
        title: "Count",
      });

      this.appendCounts(tempTtObj, this.tagTypesUnique, "tagType");
      this.appendCounts(
        tempPdObj,
        this.partnerDomainsUnique,
        "partnerDomain",
        "beaconId"
      );
      this.appendCounts(
        tempRdObj,
        this.redirectDomainsUnique,
        "redirectDomain",
        "beaconId"
      );
      this.appendCounts(tempCcObj, this.countriesUnique, "cc");
      let dupkeys = this.mergeCounts(
        this.partnerDomainsUnique,
        "beaconId",
        "partnerDomain"
      );
      this.mergeDuplicates(dupkeys, this.countsPartnerBeaconSP, "partnerDomain");
      this.mergeDuplicates(dupkeys, this.countsCountriesPBSP, "partnerDomain_cc");
      this.countsPixelSP.forEach((cPSP, i) => {
        self.tagTypesUnique.forEach((ttu) => {
          ttu[cPSP.day] = cPSP.tagType[ttu.tagType];
        });
      });

      this.countsRedirectPixelSP.forEach((cRPSP, i) => {
        self.redirectDomainsUnique.forEach((rdu) => {
          let k = rdu.beaconId + ":" + rdu.redirectDomain;
          rdu[cRPSP.day] = cRPSP.partnerDomain[k];
        });
      });

      this.countsPartnerBeaconSP.forEach((cPBSP, i) => {
        if (!self.countsPartnerBeaconSP[i].partnerDomain) {
          self.countsPartnerBeaconSP[i].partnerDomain = {};
        }
        self.countsPartnerBeaconSP[i].partnerDomain["All:All"] = 0;
        for (let key in cPBSP.partnerDomain) {
          if (key !== "All:All" && cPBSP.partnerDomain[key]) {
            self.countsPartnerBeaconSP[i].partnerDomain["All:All"] +=
              cPBSP.partnerDomain[key];
          }
        }
        self.partnerDomainsUnique.forEach((pdu) => {
          let k = pdu.beaconId + ":" + pdu.partnerDomain;
          if (cPBSP.partnerDomain[k]) {
            pdu[cPBSP.day] = self.countsPartnerBeaconSP[i].partnerDomain[k] || 0;
          }
          if (k == "All:All") {
            pdu.count += self.countsPartnerBeaconSP[i].partnerDomain[k];
          }
        });
      });

      this.countsCountriesTTSP.forEach((ccTTSP, i) => {
        if (!self.countsCountriesTTSP[i].tagType_cc) {
          self.countsCountriesTTSP[i].tagType_cc = {};
        }

        self.countsCountriesTTSP[i].tagType_cc["All:All"] = {};
        for (let key in ccTTSP.tagType_cc) {
          for (let k in ccTTSP.tagType_cc[key]) {
            if (key !== "All:All" && ccTTSP.tagType_cc[key][k]) {
              if (!self.countsCountriesTTSP[i].tagType_cc["All:All"][k]) {
                self.countsCountriesTTSP[i].tagType_cc["All:All"][k] =
                  ccTTSP.tagType_cc[key][k];
              } else {
                self.countsCountriesTTSP[i].tagType_cc["All:All"][k] +=
                  ccTTSP.tagType_cc[key][k];
              }
            }
          }
        }
      });

      this.countsCountriesPBSP.forEach((ccPBSP, i) => {
        if (!self.countsCountriesPBSP[i].partnerDomain_cc) {
          self.countsCountriesPBSP[i].partnerDomain_cc = {};
        }
        self.countsCountriesPBSP[i].partnerDomain_cc["All:All"] = {};
        for (let key in ccPBSP.partnerDomain_cc) {
          if (ccPBSP.partnerDomain_cc[key]) {
            for (let k in ccPBSP.partnerDomain_cc[key]) {
              if (key !== "All:All" && ccPBSP.partnerDomain_cc[key][k]) {
                if (!self.countsCountriesPBSP[i].partnerDomain_cc["All:All"][k]) {
                  self.countsCountriesPBSP[i].partnerDomain_cc["All:All"][k] =
                    ccPBSP.partnerDomain_cc[key][k];
                } else {
                  self.countsCountriesPBSP[i].partnerDomain_cc["All:All"][k] +=
                    ccPBSP.partnerDomain_cc[key][k];
                }
              }
            }
          }
        }
      });

      this.filteredCountsPixel = this.tagTypesUnique.filter((obj) => {
        return obj.count > this.threshold_tagType;
      });
      this.filteredCountsPartnerBeacon = this.partnerDomainsUnique.filter((obj) => {
        return obj.count > this.threshold_partnerBeacon && obj.beaconId != "All";
      });
      this.filteredCountsRedirectPixel = this.redirectDomainsUnique.filter((obj) => {
        return obj.count > this.threshold_redirect;
      });
      this.filterDailyCountsCountryTT("All:All", "All:All");
      this.showDaySplitTable = true;
      this.showCountryDailyTable = true;
    },

    filterDailyCountsCountryTT(tagType, country) {
      let self = this;

      this.countsCountriesTTSP.forEach((cCTTSP, i) => {
        self.countriesUnique.forEach((ccu) => {
          ccu[cCTTSP.day] = cCTTSP.tagType_cc[tagType][ccu.cc];
        });
      });
      this.filteredCountsCountry = this.countriesUnique.filter((obj) => {
        return country == "All:All"
          ? obj.count > this.threshold_country
          : obj.count > this.threshold_country && obj.cc == country;
      });
    },

    showSplitByStatus(splitByStatus) {
      let self = this;
      this.filteredSplitByStatusCount = null;
      if (splitByStatus) {
        this.dailyCountryStatusColumns = [];

        this.dailyCountryStatusColumns.push({
          data: "cc",
          title: "Country",
          rowspan: 2,
        });

        this.countsCountriesPBSP.forEach((cCTTSP, i) => {
          self.dailyCountryStatusColumns.push({
            data: cCTTSP.day,
            title: cCTTSP.day,
            colspan: 4,
          });
          self.dailyCountryStatusColumns.push({
            data: "success",
            title: "Success",
          });
          self.dailyCountryStatusColumns.push({
            data: "failed",
            title: "Failed",
          });
          self.dailyCountryStatusColumns.push({
            data: "timeout",
            title: "Timeout",
          });
          self.dailyCountryStatusColumns.push({
            data: "total",
            title: "Total",
          });
        });

        this.splitByStatusCounts = [];
        for (let obj of this.countriesUnique) {
          let splitByStatusCountObj = {};
          splitByStatusCountObj.cc = obj.cc;
          for (let PBSPObj of this.countsCountriesPBSP) {
            splitByStatusCountObj.success = this.getDayCountStatusSplit(
              PBSPObj.day,
              "All:All",
              obj.cc,
              "success"
            );
            splitByStatusCountObj.failed = this.getDayCountStatusSplit(
              PBSPObj.day,
              "All:All",
              obj.cc,
              "failure"
            );
            splitByStatusCountObj.timeout = this.getDayCountStatusSplit(
              PBSPObj.day,
              "All:All",
              obj.cc,
              "timeout"
            );
            splitByStatusCountObj.total = this.getDayCountStatusSplit(
              PBSPObj.day,
              "All:All",
              obj.cc,
              "_"
            );
          }
          this.splitByStatusCounts.push(splitByStatusCountObj);
        }
        this.filteredSplitByStatusCount = this.splitByStatusCounts.filter((obj) => {
          return typeof obj.total !== "undefined" && obj.total !== null;
        });

        this.showsplitByStatusTable = true;
      } else {
        this.showsplitByStatusTable = false;
      }
    },

    getDayCountStatusSplit(date, pd, cc, status) {
      let d = date.replace(/-/g, "");
      let key = d + pd + cc + status;
      return this.countriesPBLatency[key];
    },

    loadPidCount() {
      let self = this;
      let s = this.today,
        e = this.today,
        query_name = this.cid + "_counts_by_pid",
        query_params =
          'where=[{"key":"event_date","op":">=","val":[' +
          s +
          ']},{"key":"event_date","op":"<=","val":[' +
          e +
          "]}]";

      if (this.reportType == "partner") {
        query_params +=
          "&select=event_date AS Date, pid AS Pid, host_name " +
          "AS HostName, tag_type AS TagType, sum(counts) AS Counts" +
          "&groupby=GROUP BY event_date,pid,host_name,tag_type";
      } else {
        query_name = this.cid + "_counts_cc_by_pid";
        query_params +=
          "&select=event_date AS Date, pid AS Pid, host_name " +
          "AS HostName, country_code AS CC, tag_type AS TagType, counts AS Counts";
      }
      axios
        .post(
          this.$store.state.pailUrl +
          `/v1/cids/` +
          this.cid +
          "/named_queries/" +
          query_name +
          "/execute?" +
          encodeURI(query_params)
        )
        .then(function (response) {
          var query_id = response.data.query_execution_id;
          this.loadingPidData = true;
          if (this.$store.state.environment === "test") {
            switch (this.reportType) {
              case "partner":
                this.pidCounts = [];
                query_id = "pidReport";
                break;
              case "countries":
                this.pidCcCounts = [];
                query_id = "pidCCReport";
                break;
            }
            self.sleep(100).then(function () {
              self.getQueryData(query_id, 120);
            });
          } else {
            if (query_id != "" && query_id != undefined) {
              self.sleep(2000).then(function () {
                self.getQueryData(query_id, 120);
              });
            } else {
              alert("Failed to submit query on athena, please contact support...");
              self.loadingPidData = false;
            }
          }
        })
        .catch((error) => {
          if (error.response.data.error) self.error = error.response.data.error;
          else if (error.response.data.message) self.error = error.response.data.message;
          else self.error = error.message;
        });
    },

    getQueryData(query_id, counter) {
      let self = this;
      axios
        .get(
          this.$store.state.pailUrl +
          `/v1/cids/` +
          this.cid +
          "/query_executions/" +
          query_id
        )
        .then(function (response) {
          if (response.data.message) {
            var errMsg = JSON.stringify(response.data.message);
            if (
              (errMsg.includes("QUEUED") || errMsg.includes("RUNNING")) &&
              counter > 0
            ) {
              counter--;
              self.sleep(5000).then(function () {
                self.getQueryData(query_id, counter, self.cid);
              });
            } else {
              self.loadingPidData = false;
            }
          } else {
            self.loadingPidData = false;
            if (self.getPidCounts) {
              if (response.data.partial_result) {
                axios
                  .get(
                    self.$store.state.pailUrl +
                    `/v1/cids/` +
                    self.cid +
                    "/query_result_file/" +
                    query_id
                  )
                  .then(function (resp) {
                    var data = resp.data.replace(/"/g, "").split("\n");
                    var column_info = data.shift().split(",");
                    switch (self.reportType) {
                      case "partner":
                        self.pidCounts = self.convertToTableJson({
                          column_info: column_info,
                          data: data,
                        });
                        break;
                      case "countries":
                        self.pidCcCounts = self.convertToTableJson({
                          column_info: column_info,
                          data: data,
                        });
                        break;
                    }
                  });
              } else {
                switch (self.reportType) {
                  case "partner":
                    self.pidCounts = self.convertToTableJson(response.data);
                    break;
                  case "countries":
                    self.pidCcCounts = self.convertToTableJson(response.data);
                    break;
                }
              }
            } else {
              self.pidCounts = [];
              self.pidCcCounts = [];
            }
          }
        })
        .catch((error) => {
          if (error.response.data.error) self.error = error.response.data.error;
          else if (error.response.data.message) self.error = error.response.data.message;
          else self.error = error.message;
        });
    },

    convertToTableJson(obj) {
      var c = [];
      for (var i = 0; i < obj.data.length; i++) {
        var temp = {};
        for (var j = 0; j < obj.column_info.length; j++) {
          if (obj.column_info[j].name == "Counts") {
            temp[obj.column_info[j].name] = parseInt(obj.data[i][j]) | 0;
          } else {
            temp[obj.column_info[j].name] = obj.data[i][j];
          }
        }
        c.push(temp);
      }
      return c;
    },

    sleep(time) {
      return new Promise(function (resolve) {
        setTimeout(resolve, time);
      });
    },

    mergeCounts(src, pkey, skey) {
      let uniqKeys = {};
      let dupKeys = {};
      for (let i = 0; i < src.length; i++) {
        if (uniqKeys[src[i][pkey]]) {
          if (src[i][skey] == "NA" || src[i][skey] == uniqKeys[src[i][pkey]][skey]) {
            uniqKeys[src[i][pkey]].count += src[i].count;
            dupKeys[uniqKeys[src[i][pkey]][pkey] + ":" + uniqKeys[src[i][pkey]][skey]] =
              src[i][pkey] + ":" + src[i][skey];
            src.splice(i, 1);
            i--;
          } else if (uniqKeys[src[i][pkey]][skey] == "NA") {
            uniqKeys[src[i][pkey]][skey] = src[i][skey];
            uniqKeys[src[i][pkey]].count += src[i].count;
            src.splice(i, 1);
            i--;
          }
        } else {
          uniqKeys[src[i][pkey]] = src[i];
        }
      }
      return dupKeys;
    },

    appendCounts(input, output, keyName, splitKeyname) {
      for (let k in input) {
        let v = {
          count: input[k],
        };
        if (splitKeyname) {
          let m = k.match(/^(([a-z]-[a-z0-9]*)|NA):(.*)$/);
          if (m) {
            v[splitKeyname] = m[1];
            v[keyName] = m[3];
          } else {
            v[splitKeyname] = "NA";
            v[keyName] = k;
          }
        } else {
          v[keyName] = k;
        }
        if (keyName == "partnerDomain" && splitKeyname == "beaconId") {
          v["description"] = this.getBeaconDescription(v[splitKeyname]);
        }
        output.push(v);
      }
    },

    transformCounts(src, dst) {
      for (let tt in src) {
        if (tt in dst) {
          dst[tt] += src[tt];
        } else {
          dst[tt] = src[tt];
        }
      }
    },

    transformDailyCounts(date, src, dst) {
      for (let tt in src) {
        if (tt in dst) {
          dst[tt] += src[tt];
        } else {
          dst[tt] = src[tt];
        }
      }
    },

    mergeDuplicates(dupKeys, dst, key) {
      let self = this;
      if (dst) {
        for (let k in dupKeys) {
          dst.forEach(function (obj) {
            if (obj[key][k] && obj[key][dupKeys[k]]) {
              obj[key][k] = self.mergeObjs(obj[key][k], obj[key][dupKeys[k]]);
            } else if (obj[key][dupKeys[k]]) {
              obj[key][k] = obj[key][dupKeys[k]];
            }
          });
        }
      }
    },

    mergeObjs(src, dst) {
      if (typeof src == "number") {
        src += dst;
      } else if (typeof src == "object") {
        for (var k in src) {
          if (src[k] && dst[k]) {
            src[k] = this.mergeObjs(src[k], dst[k]);
          }
        }
      }
      return src;
    },

    getBeaconDescription(bID) {
      let desc = "";
      let found = false;
      for (let i = 0; i < this.classItems.length; i++) {
        if (found) {
          break;
        }
        let clsObj = this.classItems[i];
        if (!this.currentCls || this.currentCls == clsObj.cls) {
          if (clsObj && clsObj.pixels && clsObj.pixels.items) {
            for (let j = 0; j < clsObj.pixels.items.length; j++) {
              if (clsObj.pixels.items[j].beaconId == bID) {
                found = true;
                desc = clsObj.pixels.items[j].description;
                break;
              }
            }
          }
        }
      }
      return desc;
    },

    exportCSV(sufix, data) {
      if (data && data.length) {
        let fileName = `${this.fromDate}_${this.toDate}_${sufix}`;
        csv.exportCSV(fileName, data);
      }
    },

    updateCountriesPBLatencyCounts(key, count) {
      if (this.countriesPBLatency[key]) {
        this.countriesPBLatency[key] += count;
      } else {
        this.countriesPBLatency[key] = count;
      }
    },

    dateDiffInDays(fromDate, toDate) {
      let hours = dayjs(toDate).diff(dayjs(fromDate), "hours");
      const diffDays = Math.floor(hours / 24);
      return diffDays;
    },

    async aggCounts(
      cls,
      fromDate,
      toDate,
      startHour = "00",
      endHour = "23",
      isCC = false,
      isDailyAgg = false
    ) {
      try {
        let timeRanges = generateDayAndHourAndRawMetricsTimeRanges(
          fromDate,
          toDate,
          startHour,
          endHour,
          isCC
        );
        if (timeRanges.length === 0) {
          return {};
        }
        console.log("timeRanges: ", timeRanges);

        let fetchAllDataForRange = async (range) => {
          if (!range.start_time || !range.end_time || !range.metrics_name) {
            return [];
          }

          let headers = isDailyAgg
            ? isCC
              ? [
                "time",
                "tag_type",
                "partner_domain",
                "beacon_id",
                "country_code",
                "count",
              ]
              : ["time", "tag_type", "partner_domain", "beacon_id", "count"]
            : isCC
              ? ["tag_type", "partner_domain", "beacon_id", "country_code", "count"]
              : ["tag_type", "partner_domain", "beacon_id", "count"];

          let countsPayload = {
            start_time: range.start_time,
            end_time: range.end_time,
            aggregate: true,
            filter_dimensions: {
              cid: this.cid,
            },
            metrics: {
              [range.metrics_name]: {
                version: "1.0.0",
                header: headers,
              },
            },
          };
          if (cls) {
            countsPayload.filter_dimensions.class = cls;
          }
          return getCountsData(
            this.$store.state.countsUrl,
            this.cid,
            this.$store.state.accessToken,
            countsPayload
          );
        };
        let requests = timeRanges.map((range) => fetchAllDataForRange(range));
        let responses = await Promise.all(requests);
        let obj = {
          partnerBeacon: {},
          redirect: {},
          tagType: {},
          ...(isCC && {
            countryCode: {},
            tagType_countryCode: {},
            partnerBeacon_countryCode: {},
          }),
        };
        let countsData = isDailyAgg ? {} : JSON.parse(JSON.stringify(obj));

        responses.flat().forEach((data) => {
          let time, tagType, partnerDomain, beaconId, countryCode, count;
          if (isDailyAgg) {
            if (isCC) {
              [time, tagType, partnerDomain, beaconId, countryCode, count] = data;
            } else {
              [time, tagType, partnerDomain, beaconId, count] = data;
            }
            let date = dayjs(time).format("YYYYMMDD");
            if (!countsData[date]) {
              countsData[date] = JSON.parse(JSON.stringify(obj));
            }
          } else {
            if (isCC) {
              [tagType, partnerDomain, beaconId, countryCode, count] = data;
            } else {
              [tagType, partnerDomain, beaconId, count] = data;
            }
          }
          let target = isDailyAgg
            ? countsData[dayjs(time).format("YYYYMMDD")]
            : countsData;
          if (isCC) {
            if (!target["countryCode"][countryCode]) {
              target["countryCode"][countryCode] = 0;
            }
            target["countryCode"][countryCode] += count;
          }
          if (beaconId === "NA" && partnerDomain === "NA") {
            if (!target["tagType"][tagType]) {
              target["tagType"][tagType] = 0;
            }
            target["tagType"][tagType] += count;
            if (isCC) {
              if (!target["tagType_countryCode"][tagType]) {
                target["tagType_countryCode"][tagType] = {};
              }
              if (!target["tagType_countryCode"][tagType][countryCode]) {
                target["tagType_countryCode"][tagType][countryCode] = 0;
              }
              target["tagType_countryCode"][tagType][countryCode] += count;
            }
          } else if (beaconId !== "NA" && tagType === "partner_beacon") {
            let key = `${beaconId}:${partnerDomain}`;
            if (!target["partnerBeacon"][key]) {
              target["partnerBeacon"][key] = 0;
            }
            target["partnerBeacon"][key] += count;
            if (isCC && isDailyAgg) {
              if (!target["partnerBeacon_countryCode"][key]) {
                target["partnerBeacon_countryCode"][key] = {};
              }
              if (!target["partnerBeacon_countryCode"][key][countryCode]) {
                target["partnerBeacon_countryCode"][key][countryCode] = 0;
              }
              target["partnerBeacon_countryCode"][key][countryCode] += count;
            }
          } else if (partnerDomain !== "NA" && tagType === "302_redirect") {
            let key = `${beaconId}:${partnerDomain}`;
            if (!target["redirect"][key]) {
              target["redirect"][key] = 0;
            }
            target["redirect"][key] += count;
          }
        });
        return sortKeysRecursively(countsData);
      } catch (error) {
        console.error("Error processing aggCounts:", error);
        throw error;
      }
    },

    initiateClass() {
      if (
        this.$store.state.aut.currentClass &&
        this.$store.state.aut.currentClass[this.$store.state.currentClient.cid]
      )
        this.currentCls = this.$store.state.aut.currentClass[
          this.$store.state.currentClient.cid
        ];
      this.currentClsLL = this.$store.state.aut.currentClass[this.$store.state.currentClient.cid];
    },
  },
};
</script>

<style scoped>
.class-menu {
  margin-bottom: 1.5rem;
}

.col-centered {
  float: none;
  margin: 0 auto;
}

.form-check-input:checked {
  background-color: #2c7be5 !important;
  border-color: #2c7be5;
}

.form-check-input {
  background-color: #6e84a3;
}

.spinner-border {
  width: 1em;
  height: 1em;
}

/* Every filter control matches the btn-sm Refresh button:
   0.8125rem text x 1.75 line-height + 0.25rem padding + 2px border.
   The -sm inputs keep a 1.5 line-height, about 3px short, so lift it.
   ::v-deep because flatpickr creates the visible alt input outside the template. */
.ll-filters ::v-deep(.form-control-sm),
.ll-filters .form-select-sm {
  line-height: 1.75;
}

/* Segmented control, matching the PAICE Settings editor-mode switch */
.ll-presets {
  display: inline-flex;
  align-items: stretch;
  gap: 2px;
  height: calc(0.8125rem * 1.75 + 0.25rem + 2px);
  padding: 2px;
  background-color: #f9fbfd;
  border: 1px solid #edf2f9;
  border-radius: 0.25rem;
}

.ll-presets .btn {
  display: inline-flex;
  align-items: center;
  padding: 0 0.6rem;
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1;
  color: #6e84a3;
  background-color: transparent;
  border: 0;
  border-radius: 0.2rem;
}

.ll-presets .btn:hover {
  color: #12263f;
}

.ll-presets .btn.active {
  color: #2c7be5;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(18, 38, 63, 0.08);
}

.ll-loading .spinner-border {
  width: 2rem;
  height: 2rem;
}

::v-deep(.flatpickr-alt-input) {
  background-color: white !important;
  color: #000 !important;
}
</style>

<style>
body.dark-mode .flatpickr-alt-input {
  background-color: #22252b !important;
  color: #e1e3e8 !important;
}

body.dark-mode .ll-presets {
  background-color: #111317;
  border-color: #2e3238;
}

body.dark-mode .ll-presets .btn {
  color: #a0a4b8;
}

body.dark-mode .ll-presets .btn:hover {
  color: #e1e3e8;
}

body.dark-mode .ll-presets .btn.active {
  color: #7ab0ff;
  background-color: #22252b;
  box-shadow: none;
}

/* Unscoped: the .ll-confirm-* markup also renders inside the confirm modal (Confirm.vue, via v-html) */


/* Version picker */
.ll-filters {
  row-gap: 1.75rem !important;
  /* room for the absolutely-placed status line when the row wraps */
}

.ll-version {
  position: relative;
}

.ll-version-toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 16rem;
  max-width: 28rem;
}

.ll-version-name {
  font-weight: 600;
  white-space: nowrap;
}

.ll-version-dims {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  color: #6e84a3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ll-version-menu {
  min-width: 100%;
  max-height: 18rem;
  overflow-y: auto;
}

.ll-version-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8125rem;
}

.ll-version-item.selected {
  background-color: #f1f4f8;
}

.ll-version-check {
  width: 0.875rem;
  color: #2c7be5;
  font-size: 0.75rem;
}

.ll-version-help {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 0.2rem;
  font-size: 0.75rem;
  white-space: nowrap;
}

.ll-version-help i {
  margin-right: 0.25rem;
}

.ll-version-help.is-deployed {
  /* color: #00a565; */
  color: var(--bs-primary);
}

.ll-version-help.is-pending {
  color: #b98700;
}

.ll-active-until-expired {
  color: #b98700;
}

.ll-version-help.is-previous {
  color: #95aac9;
}

/* Undeployed-version notice */
.ll-notice {
  display: flex;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  font-size: 0.8125rem;
  color: #12263f;
  background-color: rgba(110, 132, 163, 0.08);
  border: 1px solid rgba(110, 132, 163, 0.25);
  border-left: 3px solid #6e84a3;
  border-radius: 0.3rem;
}

.ll-notice-icon {
  margin-top: 0.15rem;
  color: #6e84a3;
}

.ll-notice-title {
  margin-bottom: 0.15rem;
  font-weight: 600;
}

.ll-notice-body {
  color: #3b506c;
}

.ll-notice-body a:hover {
  text-decoration: underline;
}

/* Inline with the hint text, so it keeps the hint's size and baseline */
.ll-switch-to-prod {
  font-size: inherit;
  font-weight: 600;
  vertical-align: baseline;
  text-decoration: none;
}

.ll-switch-to-prod:hover {
  text-decoration: underline;
}

/* Confirm modal content */
.ll-confirm-hero {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  margin-bottom: 1.25rem;
}

.ll-confirm-hero-icon {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  font-size: 1rem;
  border-radius: 50%;
}

.ll-confirm-hero.is-on .ll-confirm-hero-icon {
  color: #2c7be5;
  background-color: rgba(44, 123, 229, 0.1);
}

.ll-confirm-hero.is-off .ll-confirm-hero-icon {
  color: #e63757;
  background-color: rgba(230, 55, 87, 0.1);
}

.ll-confirm-hero-title {
  font-weight: 600;
  color: #12263f;
}

.ll-confirm-hero-sub {
  font-size: 0.8125rem;
  color: #6e84a3;
}

.ll-confirm-card {
  padding: 0.875rem 1rem;
  margin-bottom: 1.25rem;
  background-color: #f9fbfd;
  border: 1px solid #e3ebf6;
  border-radius: 0.375rem;
}

.ll-confirm-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.25rem;
}

.ll-confirm-label {
  margin-bottom: 0.4rem;
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #95aac9;
  text-transform: uppercase;
}

.ll-confirm-version {
  margin-bottom: 0.75rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: #12263f;
}

.ll-confirm-version:last-child {
  margin-bottom: 0;
}

.ll-confirm-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
}

.ll-confirm-chip {
  padding: 0.125rem 0.5rem;
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.75rem;
  color: #3b506c;
  background-color: #fff;
  border: 1px solid #e3ebf6;
  border-radius: 0.25rem;
}

.ll-confirm-facts {
  padding: 0;
  margin: 0;
  list-style: none;
}

.ll-confirm-facts li {
  display: flex;
  align-items: baseline;
  gap: 0.6rem;
  font-size: 0.8125rem;
  color: #6e84a3;
}

.ll-confirm-facts li + li {
  margin-top: 0.35rem;
}

.ll-confirm-facts i {
  width: 1rem;
  text-align: center;
  color: #95aac9;
}

/* Dark mode */
body.dark-mode .ll-version-dims,
body.dark-mode .ll-confirm-hero-sub,
body.dark-mode .ll-confirm-facts li {
  color: #a0a4b8;
}

body.dark-mode .ll-version-item.selected {
  background-color: #2a3a50;
}

body.dark-mode .ll-version-check {
  color: #7ab0ff;
}

body.dark-mode .ll-version-help.is-deployed {
  /* color: #4ee0a0; */
  color: var(--bs-primary);
}

body.dark-mode .ll-version-help.is-pending,
body.dark-mode .ll-active-until-expired {
  color: #f6c343;
}

body.dark-mode .ll-version-help.is-previous {
  color: #6e84a3;
}

body.dark-mode .ll-notice {
  color: #e1e3e8;
  background-color: rgba(110, 132, 163, 0.12);
  border-color: rgba(110, 132, 163, 0.35);
  border-left-color: #6e84a3;
}

body.dark-mode .ll-notice-body {
  color: #a0a4b8;
}

body.dark-mode .ll-notice-icon {
  color: #95aac9;
}

body.dark-mode .ll-confirm-card {
  background-color: #22252b;
  border-color: #2e3238;
}

body.dark-mode .ll-confirm-hero-title,
body.dark-mode .ll-confirm-version {
  color: #e1e3e8;
}

body.dark-mode .ll-confirm-chip {
  color: #c4c8d4;
  background-color: #1a1d23;
  border-color: #2e3238;
}

body.dark-mode .ll-confirm-label,
body.dark-mode .ll-confirm-facts i {
  color: #6e84a3;
}

body.dark-mode .ll-confirm-hero.is-on .ll-confirm-hero-icon {
  color: #7ab0ff;
  background-color: rgba(44, 123, 229, 0.18);
}

body.dark-mode .ll-confirm-hero.is-off .ll-confirm-hero-icon {
  color: #ff7a93;
  background-color: rgba(230, 55, 87, 0.18);
}
</style>
